import { render, staticRenderFns } from "./passCrewList.vue?vue&type=template&id=60daa35f&scoped=true"
import script from "./passCrewList.vue?vue&type=script&lang=js"
export * from "./passCrewList.vue?vue&type=script&lang=js"
import style0 from "./passCrewList.vue?vue&type=style&index=0&id=60daa35f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60daa35f",
  null
  
)

export default component.exports